"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TotalComplexList = void 0;
const complex_utils_1 = require("complex-utils");
const complex_data_1 = require("complex-data");
class TotalComplexList extends complex_data_1.ComplexList {
    constructor(initOption) {
        initOption.$getData = function () {
            return initOption.select.$loadData(true);
        };
        super(initOption);
        this.$select = initOption.select;
        this.$onLife('loaded', {
            data: () => {
                this.$parseList();
            }
        });
    }
    $parseList() {
        const search = this.$module.search;
        const searchData = this.$getSearch();
        let list = this.$select.getList({}).filter((item) => {
            if (search) {
                for (const prop in searchData) {
                    if ((0, complex_utils_1.isExist)(searchData[prop])) {
                        const ditem = search.$module.dictionary.getItem(prop);
                        if (ditem) {
                            const type = ditem.$mod.search.type;
                            if (type === 'input' || type === 'textArea') {
                                if (item[prop].indexOf(searchData[prop]) === -1) {
                                    return false;
                                }
                            }
                            else {
                                if (item[prop] !== searchData[prop]) {
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
            return true;
        });
        const size = list.length;
        if (this.$module.pagination) {
            list = this.$module.pagination.formatList(list);
        }
        this.$formatList(list, size);
    }
}
exports.TotalComplexList = TotalComplexList;
exports.default = TotalComplexList;
